import { render, staticRenderFns } from "./500-internal-server-error.vue?vue&type=template&id=24116202"
import script from "./500-internal-server-error.vue?vue&type=script&lang=js"
export * from "./500-internal-server-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports